<template>
  <div class="sale-setup">
    <Keyboard v-model="keyboard" layout="compact" />

    <!-- Fila: Tipo Venta -->
    <div class="setup-head">
      <div class="field field-tipo">
        <label for="tipoVenta">Tipo de venta</label>
        <select id="tipoVenta" v-model="localValue.tipo">
          <option v-for="item in data" :key="item.intPOSTipoVenta" :value="item.intPOSTipoVenta">
            {{ item.strNombre }}
          </option>
        </select>
      </div>

      <!-- Clave -->
      <div class="field field-clave">
        <label for="clave">Nombre</label>
        <input
          id="clave"
          type="text"
          v-model="localValue.clave"
          @click="showKeyboard($event)"
        />
      </div>
    </div>

    <!-- Formulario cliente (solo LLEVAR + config 35 activa) -->
    <transition name="slide-fade">
      <div v-if="mostrarDatosCliente" class="inline-form open">
        <!-- Teléfono (combobox con búsqueda) -->
        <div class="field">
          <label for="telefono">Teléfono</label>
          <input
            id="telefono"
            type="text"
            :readonly="disabledView"
            v-model="localValue.strTelefono"
            placeholder="Buscar…"
            @focus="cargarTelefonos()"
            list="telefonosList"
          />
          <datalist id="telefonosList">
            <option
              v-for="c in clientes.data"
              :key="c.strTelefono"
              :value="c.strTelefono"
            ></option>
          </datalist>
        </div>

        <!-- Nombre -->
        <div class="field">
          <label for="nombre">Nombre</label>
          <input
            id="nombre"
            type="text"
            :readonly="disabledView"
            v-model="localValue.strNombre"
          />
        </div>

        <!-- E-mail -->
        <div class="field">
          <label for="email">E-mail</label>
          <input
            id="email"
            type="text"
            :readonly="disabledView"
            v-model="localValue.strEmail"
          />
        </div>

        <!-- Campos ocultos (los dejo para que el watch y save sigan funcionando) -->
        <div class="field d-none">
          <input v-model="localValue.strColonia" type="text" />
        </div>
        <div class="field d-none">
          <input v-model="localValue.strEntreCalle" type="text" />
        </div>
        <div class="field d-none">
          <input v-model="localValue.strPoblacion" type="text" />
        </div>

        <!-- Acción -->
        <div v-if="!disabledView" class="form-actions">
          <button
            type="button"
            class="small-btn"
            :disabled="loading"
            @click="save()"
          >
            {{ loading ? "Guardando…" : "Guardar" }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Keyboard from "./Keyboard.vue";
import { POSEncFunctions, POSCliente } from "../controllers/POSController.js";
import { Session, Toast, ErrorWeb, Data } from "../controllers/DataController.js";

export default {
  name: "TipoVentaCliente",
  props: {
    value: { required: true },
    data: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    tipo: { type: Object, default: () => ({ valor: 1 }) },
    colonias: { type: Array, default: () => [] },
    repartidores: { type: Array, default: () => [] },
    orden: { type: Object, default: () => ({ intEstatus: 0 }) },
  },
  components: { Keyboard },
  data() {
    return {
      dataController: new Data(),
      search: null,
      session: new Session(),
      loading: false,
      config_35_valor: this.$config.opciones.find((c) => c.id == 35).valor,
      config_35_activo: this.$config.opciones.find((c) => c.id == 35).activo,
      keyboardSession: false,
      disabledView: !this.$config.opciones.find((c) => c.id == 35).activo,
      POSEnc: { intEstatus: 0 },
      ordenFunctions: new POSEncFunctions(this.$config.api_backend_route),
      config_17: this.$config.opciones.find((c) => c.id == 17).valor,
      telefonoBusqueda: "",
      POSCliente: new POSCliente(),
      clientes: { data: [] },
      items: [],
      localValue: this.value,
      keyboard: { visible: false, input: null },
      venta: this.data,
    };
  },
  computed: {
    esLlevar() {
      return Number(this.localValue.tipo) === 0;
    },
    mostrarDatosCliente() {
      return this.config_35_activo && this.esLlevar;
    },
  },
  methods: {
    showKeyboard(e) {
      if (this.keyboardSession && !this.disabled) {
        this.keyboard.input = e.target;
        this.keyboard.visible = true;
      }
    },
    async cargarTelefonos() {
      if (!this.localValue.strTelefono) {
        this.clientes.data = await this.ordenFunctions.clientes("");
      }
    },
    async save() {
      this.loading = true;
      try {
        const email = (this.localValue.strEmail || "").trim();

        if (email) {
          if (/\s/.test(email)) throw "El email no puede contener espacios";
          if (!email.includes("@")) throw "El email debe contener @";
          if ((email.match(/@/g) || []).length !== 1)
            throw "El email debe contener un solo @";

          const partes = email.split("@");
          if (!partes[0]) throw "El email debe tener un usuario antes de @";
          if (!partes[1]) throw "El email debe tener un dominio después de @";
          if (!partes[1].includes("."))
            throw "El email debe tener un dominio válido, por ejemplo: usuario@hotmail.com";
          if (email.startsWith(".") || email.endsWith("."))
            throw "El email no puede comenzar ni terminar con punto";

          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(email)) throw "El formato del email no es válido";
          this.localValue.strEmail = email;
        }

        if (this.localValue.intCliente > 0) {
          await this.ordenFunctions.editarCliente(
            this.localValue,
            this.session.empresa,
            this.session.usuario,
            this.session.terminal
          );
          this.$toast.success("Cliente actualizado con exito", new Toast());
        } else {
          if (this.localValue.strTelefono) {
            const telefono = this.localValue.strTelefono.replace(/\D/g, "");
            if (telefono.length > 0 && telefono.length < 10)
              throw "El telefono debe tener al menos 10 numeros";
          }
          let response = await this.ordenFunctions.saveCliente(
            this.localValue,
            this.session.empresa,
            this.session.usuario,
            this.session.terminal
          );
          this.localValue.intCliente = response.intCliente;
          this.$toast.success("Cliente agregado con exito", new Toast());
        }
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    async cargarCliente(telefono) {
      if (!telefono) return;
      let data = await this.ordenFunctions.dataclientes(telefono.strTelefono);
      if (data) {
        this.localValue.intCliente = data.intCliente;
        this.localValue.strColonia = data.strColonia;
        this.localValue.strDireccion = data.strDireccion;
        this.localValue.strEntreCalle = data.strEntreCalle;
        this.localValue.strNombre = data.strNombre;
        this.localValue.strNumeroExterior = data.strNumeroExterior;
        this.localValue.strNumeroInterior = data.strNumeroInterior;
        this.localValue.strPoblacion = data.strPoblacion;
        this.localValue.strReferencia = data.strReferencia;
        this.localValue.strTelefono = data.strTelefono;
        this.localValue.strTelefonoLlevar = data.strTelefono;
        this.localValue.strRFC = data.strRFC;
        this.localValue.strEmail = data.strEmail;
      }
    },
    querySelections(v) {
      this.loading = true;
      setTimeout(() => {
        this.items = this.clientes.data.filter((e) => {
          return (e.strTelefono || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },
    seleccionarCliente(cliente) {
      this.buscarCliente && (this.buscarCliente.isVisible = false);
      this.localValue.intCliente = cliente.intCliente || 0;
      this.localValue.strTelefono = cliente.strTelefono || "";
      this.localValue.strNombre = cliente.strNombre || "";
      this.localValue.strColonia = cliente.strColonia || "";
      this.localValue.strDireccion = cliente.strDireccion || "";
      this.localValue.strEntreCalle = cliente.strEntreCalle || "";
      this.localValue.strNumeroExterior = cliente.strNumeroExterior || "";
      this.localValue.strNumeroInterior = cliente.strNumeroInterior || "";
      this.localValue.strPoblacion = cliente.strPoblacion || "";
      this.localValue.strReferencia = cliente.strReferencia || "";
      this.localValue.strRFC = cliente.strRFC || "";
      this.localValue.strEmail = cliente.strEmail || "";
    },
  },
  async mounted() {
    this.keyboardSession = new Session().keyboard;
    this.clientes.data = await this.ordenFunctions.clientes(
      this.localValue.strTelefono
    );
    await this.dataController.loadTipoVentas();
  },
  watch: {
    localValue(newValue) {
      this.$emit("input", newValue);
    },
    search(val) {
      val && this.querySelections(val);
    },
    config_35_activo(val) {
      this.disabledView = !val;
    },
    value(newValue) {
      this.localValue = newValue;
    },
    async ["localValue.clave"](newVal) {
      if (!newVal || newVal === "") {
        this.localValue.strTelefono = "";
        this.localValue.intCliente = 0;
        this.localValue.strNombre = "";
        this.localValue.strColonia = "";
        this.localValue.strDireccion = "";
        this.localValue.strEntreCalle = "";
        this.localValue.strNumeroExterior = "";
        this.localValue.strNumeroInterior = "";
        this.localValue.strPoblacion = "";
        this.localValue.strReferencia = "";
        this.localValue.strRFC = "";
        this.localValue.strEmail = "";
        this.clientes.data = await this.ordenFunctions.clientes("");
      }
    },
    ["localValue.tipo"](newVal) {
      const tipo = Number(newVal);
      if (tipo !== 0) {
        this.localValue.strTelefono = "";
        this.localValue.strNombre = "";
        this.localValue.strEmail = "";
        this.localValue.intCliente = 0;
      }
    },
    async ["localValue.strTelefono"](newVal) {
      let telefono =
        typeof newVal === "object" ? newVal?.strTelefono : newVal;
      if (!telefono || telefono.replace(/\D/g, "").length < 10) return;
      let data = await this.ordenFunctions.dataclientes(telefono);
      if (data) {
        this.localValue.strTelefono = telefono;
        this.localValue.intCliente = data.intCliente || 0;
        this.localValue.strNombre = data.strNombre || "";
        this.localValue.strColonia = data.strColonia || "";
        this.localValue.strDireccion = data.strDireccion || "";
        this.localValue.strEntreCalle = data.strEntreCalle || "";
        this.localValue.strNumeroExterior = data.strNumeroExterior || "";
        this.localValue.strNumeroInterior = data.strNumeroInterior || "";
        this.localValue.strPoblacion = data.strPoblacion || "";
        this.localValue.strReferencia = data.strReferencia || "";
        this.localValue.strRFC = data.strRFC || "";
        this.localValue.strEmail = data.strEmail || "";
      } else {
        this.localValue.intCliente = 0;
        this.localValue.strColonia = "";
        this.localValue.strDireccion = "";
        this.localValue.strEntreCalle = "";
        this.localValue.strNombre = "";
        this.localValue.strNumeroExterior = "";
        this.localValue.strNumeroInterior = "";
        this.localValue.strPoblacion = "";
        this.localValue.strReferencia = "";
        this.localValue.strNombre = "";
        this.localValue.strEmail = "";
      }
    },
  },
};
</script>

<style scoped>
.sale-setup {
  --primary: #0353a4;
  --primary-hover: #034582;
  --primary-light: #347ea8;
  --primary-tint: #eef5f9;
  --success: #00a63e;
  --surface: #fff;
  --surface-alt: #fafbfc;
  --border: #e2e4e8;
  --border-strong: #c7cbd1;
  --text: #1a1d23;
  --muted: #6b7280;
  --r-sm: 8px;
  --r-md: 14px;

  position: relative;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  box-shadow: 0 3px 12px rgba(17, 29, 45, 0.045);
  padding: 15px 17px;
  color: var(--text);
}

/* ==== Fila superior: tipo + clave ==== */
.setup-head {
  display: flex;
  gap: 14px;
  align-items: flex-end;
  flex-wrap: wrap;
}
.setup-head .field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.setup-head .field-tipo {
  flex: 1 1 200px;
}
.setup-head .field-clave {
  flex: 1 1 180px;
}

.field label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 4px;
  color: var(--text);
}
.field input,
.field select {
  width: 100%;
  height: 42px;
  box-sizing: border-box;
  padding: 8px 11px;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--r-sm);
  background: var(--surface);
  color: var(--text);
  font: inherit;
  font-size: 13px;
}
.field input::placeholder {
  color: var(--muted);
}
.field input:focus,
.field select:focus,
.field input:focus-visible,
.field select:focus-visible {
  outline: none;
  border-color: var(--primary-light);
  box-shadow: 0 0 0 5px rgba(52, 126, 168, 0.18);
}
.field input[readonly] {
  background: var(--surface-alt);
  color: var(--muted);
  cursor: not-allowed;
}

/* ==== Formulario cliente ==== */
.inline-form {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px 11px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}
.inline-form.open {
  display: grid;
}
.inline-form .field {
  min-width: 0;
}
.form-actions {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
}
.small-btn {
  min-height: 44px;
  background: var(--primary);
  color: #fff;
  border: 0;
  border-radius: var(--r-sm);
  padding: 10px 18px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.small-btn:hover {
  background: var(--primary-hover);
}
.small-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ==== Utilidades ==== */
.d-none {
  display: none;
}

/* ==== Transición ==== */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.18s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

/* ==== Responsive ==== */
@media (max-width: 900px) {
  .inline-form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .sale-setup {
    padding: 12px;
  }
  .setup-head {
    flex-wrap: wrap;
  }
  .setup-head .field-tipo,
  .setup-head .field-clave {
    flex: 1 1 100%;
  }
  .inline-form {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 1500px) {
  .sale-setup {
    padding: 16px 18px;
  }
  .field label {
    font-size: 15px;
  }
  .field input,
  .field select {
    height: 49px;
    font-size: 16px;
  }
  .small-btn {
    font-size: 14px;
    padding: 12px 22px;
  }
}
</style>